// 2) ImpactRibbon.tsx (bigger, horizontal, configurable color)
// Path: packages/components/src/homepage/hero/ImpactRibbon.tsx

import React from 'react';
import clsx from 'clsx';

type ColorTone =
  | 'sky'
  | 'emerald'
  | 'violet'
  | 'cyan'
  | 'slate'
  | 'pink';

const colorMap: Record<ColorTone, { bg: string; text: string; border?: string }> = {
  sky: { bg: 'bg-sky-200', text: 'text-sky-950' },
  emerald: { bg: 'bg-emerald-200', text: 'text-emerald-950' },
  violet: { bg: 'bg-violet-200', text: 'text-violet-950' },
  cyan: { bg: 'bg-cyan-200', text: 'text-cyan-950' },
  slate: { bg: 'bg-slate-200', text: 'text-slate-950' },
  pink: { bg: 'bg-pink-200', text: 'text-pink-950' },
};

export const ImpactRibbon: React.FC<{
  text?: string;
  className?: string;
  anchor?: 'corner' | 'center-top';
  color?: ColorTone;
  size?: 'md' | 'xl';
  noShadow?: boolean;
  weight?: 'normal' | 'medium' | 'semibold' | 'bold' | 'extrabold' | 'black';
}> = ({
  text = 'AI outstaffing',
  className,
  anchor = 'center-top',
  color = 'sky',
  size = 'xl',
  weight = 'extrabold',
}) => {
  const c = colorMap[color];
  const anchorCls =
    anchor === 'center-top'
      ? 'left-1/2 -translate-x-1/2 -top-4'
      : '-top-3 -left-3';

  const sizeCls =
    size === 'xl'
      ? 'px-6 py-2.5 text-xl md:text-2xl lg:text-3xl rounded-lg tracking-tight'
      : 'px-3 py-1.5 text-sm rounded-md';

  const weightCls =
    weight === 'black' ? 'font-black' :
    weight === 'extrabold' ? 'font-extrabold' :
    weight === 'bold' ? 'font-bold' :
    weight === 'semibold' ? 'font-semibold' :
    weight === 'medium' ? 'font-medium' : 'font-normal';

  return (
    <div
      className={clsx(
        'absolute z-20',
        anchorCls,
        c.bg,
        c.text,
        'border-2 border-black',
        'whitespace-nowrap',
        sizeCls,
        weightCls,
        className
      )}
    >
      {text}
    </div>
  );
};

export default ImpactRibbon;